import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * FilterChips — szybkie filtry jako chippy z animowanym aktywnym stanem.
 * Używane w Pracownicy, Raporty.
 */
function FilterChips({ filters = [], activeFilters = [], onToggle }) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {filters.map((filter) => {
        const isActive = activeFilters.includes(filter.value);
        return (
          <Chip
            key={filter.value}
            label={filter.label}
            variant={isActive ? 'filled' : 'outlined'}
            color={isActive ? 'primary' : 'default'}
            onClick={() => onToggle?.(filter.value)}
            sx={{
              fontWeight: isActive ? 700 : 500,
              borderRadius: `${theme.tokens?.primitive?.radius?.pill ?? 999}px`,
              transition: `all ${theme.tokens?.primitive?.motion?.duration?.fast ?? 160}ms ease`,
            }}
          />
        );
      })}
    </Box>
  );
}

export default FilterChips;
